import * as React from 'react';
import type {
  Classnames,
  ControlElementsProp,
  FullField,
  QueryBuilderContextProvider,
  Translations,
} from 'react-querybuilder';
import { getCompatContextProvider } from 'react-querybuilder';
import { BootstrapNotToggle } from './BootstrapNotToggle';
import { BootstrapValueEditor } from './BootstrapValueEditor';

export * from './BootstrapNotToggle';
export * from './BootstrapValueEditor';

/**
 * @group Props
 */
export const bootstrapControlElements: ControlElementsProp<FullField, string> = {
  notToggle: BootstrapNotToggle,
  valueEditor: BootstrapValueEditor,
};

/**
 * @group Props
 */
export const bootstrapControlClassnames: Partial<Classnames> = {
  actionElement: 'btn btn-sm',
  addGroup: 'btn-secondary',
  addRule: 'btn-primary',
  cloneGroup: 'btn-secondary',
  cloneRule: 'btn-secondary',
  ungroup: 'btn-secondary',
  lockGroup: 'btn-secondary',
  lockRule: 'btn-secondary',
  removeGroup: 'btn-danger',
  removeRule: 'btn-danger',
  undoAction: 'btn-secondary',
  redoAction: 'btn-secondary',
  // BootstrapValueEditor adds its own classnames
  // value: '',
  valueSelector: 'form-select form-select-sm',
};

/**
 * @group Props
 */
export const bootstrapTranslations: Partial<Translations> = {
  removeGroup: { label: <i className="bi bi-x" /> },
  removeRule: { label: <i className="bi bi-x" /> },
  cloneRule: { label: <i className="bi bi-copy" /> },
  cloneRuleGroup: { label: <i className="bi bi-copy" /> },
  ungroupRuleGroup: { label: <i className="bi bi-box-arrow-up-left" /> },
  dragHandle: { label: <i className="bi bi-grip-vertical" /> },
  lockGroup: { label: <i className="bi bi-unlock" /> },
  lockRule: { label: <i className="bi bi-unlock" /> },
  lockGroupDisabled: { label: <i className="bi bi-lock" /> },
  lockRuleDisabled: { label: <i className="bi bi-lock" /> },
  shiftActionUp: { label: <i className="bi bi-chevron-compact-up" /> },
  shiftActionDown: { label: <i className="bi bi-chevron-compact-down" /> },
  undo: { label: <i className="bi bi-arrow-counterclockwise" /> },
  redo: { label: <i className="bi bi-arrow-clockwise" /> },
};

/**
 * @group Components
 */
export const QueryBuilderBootstrap: QueryBuilderContextProvider = getCompatContextProvider({
  controlClassnames: bootstrapControlClassnames,
  controlElements: bootstrapControlElements,
  translations: bootstrapTranslations,
});
